import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import FlagIcon from 'components/shared/FlagIcon'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import ShareWithSalesRepsModal from './ShareWithSalesRepsModal'
import { Col, Row } from "react-bootstrap"
import queryString from 'query-string';
import { Tabs, Tab } from 'components/shared/Tabs'
import { getVisibleReports, findReportBySlug, resolveReport } from 'constants/reports/registry'
import PageHeader from 'components/ds/PageHeader'
import Button from 'components/shared/Button'
import DsButton from 'components/ds/Button'
import ReportsRail from './reports/ReportsRail'
import SummaryStrip from './reports/SummaryStrip'
import {brokerCreateNotes, getBgvReportHistory, getCreditCostsOverview, refreshBgvReport} from 'actions/applicants'
import FmcsaVerification from '../partial/Tabs/Fmcsa'
import Ucc from 'components/Applicants/partial/Tabs/UCC'
import Notes from 'components/Applicants/partial/Tabs/Notes'
import Messages from 'components/Applicants/partial/Tabs/Messages'
import Terms from '../partial/Tabs/Terms';
import { Verification } from '../partial/Tabs/Verification'
import { Attachments } from '../partial/Tabs/Attachments'
import TasksTab from 'components/CollaborativeTasks/TasksTab'
import { CreditCheck } from '../partial/Tabs/CreditCheck'
import { Bgv } from '../partial/Tabs/Bgv'
import Summary from '../partial/Tabs/Summary/Summary'
import BankDataSection from '../partial/Tabs/BankDataSection'
import BalanceSheet from '../partial/Tabs/BalanceSheet'
import IncomeStatement from '../partial/Tabs/IncomeStatement'
import CashFlowStatement from '../partial/Tabs/CashFlowStatement'
import Dscr from '../partial/Tabs/Dscr'
import Taxes from '../partial/Tabs/Taxes'
import CreditMemo from '../partial/Tabs/CreditMemo'
import ArBalance from '../partial/Tabs/ArBalance'
import ReputationalReport from '../partial/Tabs/ReputationalReport';
import { Status } from 'constants/chartData'
import AuthService from 'tools/AuthService'
import './applicantDetail.scss'
import ApplicationStatusDropdown from "./ApplicationStatusDropdown";
// Hiding application risk badge, to revert uncomment the section below
// import ApplicationRiskBadge from "./ApplicationRiskBadge";
import SummaryCard from "./SummaryCard";
import Overview from '../partial/Tabs/Summary/Overview'
import { Toast } from 'components/shared/Toaster'
import strings from 'strings'
import GetAllDataAlert from '../partial/Tabs/Summary/GetAllDataAlert';
import { ReportsMonitoringDrawer } from '../partial/Drawer/ReportsMonitoring';
import { ReportsMonitoringDrawerLegacy } from '../partial/Drawer/ReportsMonitoringLegacy';

// Old Header ===================================================================
import { cloneDeep } from 'lodash'
import { applicationTabs } from 'constants/constantVariables'
import { BuisnessColumns, OwnersColumn } from 'constants/application'
import TableComponent from 'components/shared/TableComponent'
import BusinessModal from 'components/Applicants/partial/Dialog/BusinessModal'
import OwnerModal from 'components/Applicants/partial/Dialog/OwnerModal'
import EditIcon from 'styles/images/icons/edit.svg'
import AddIcon from 'styles/images/icons/add.svg'
import NewUCCTabContent from '../partial/Tabs/NewUCC/index';
import { useAppContext } from '../../../context/AppContext';
import SosTabContent from '../partial/Tabs/SecretaryOfState/SosTabContent';
import SamgovTabContent from '../partial/Tabs/Samgov/SamgovTabContent';
import NppesTabContent from '../partial/Tabs/Nppes/NppesTabContent';
import LeieTabContent from '../partial/Tabs/Leie/LeieTabContent';
import HealthcareSearchTabContent from '../partial/Tabs/HealthcareSearch/HealthcareSearchTabContent';
import StateMedicaidTabContent from '../partial/Tabs/StateMedicaid/StateMedicaidTabContent';
import TinVerification from "../partial/Tabs/TinVerification/TinVerification";
import MotusTab from "../partial/Tabs/Motus/MotusTab";
// ==============================================================================

/**
 *
 * @param {String} name business name
 * @param {String} status application status
 * @param {Function} setChangeStatus function to change the status value in dropdown
 * @param {Function} updateStatus function to call API to update the status of application
 * @param {String} selectedStatus dropdown selected value
 * @returns
 */
const ApplicantHeader = (props) => {
    const {
        name,
        status,
        updateStatus,
        dispatchProcessing,
        applicantUUID,
        showMonitoringEnabledBtn,
        onMonitoringClick, // <-- Add this prop
        isBrokerCustomer,
        flaggedBusinessType
    } = props
    const { monitoringEnabled, isReadOnlyUser, salesRepUsersEnabled } = AuthService.getClientFeatures()
    const canShare = salesRepUsersEnabled && AuthService.hasPrivilege('SHARE_APPLICATION')
    const [shareOpen, setShareOpen] = useState(false)
    return (
        <PageHeader
            className='applicantPageHeader'
            breadcrumbs={[
                { label: strings.APPLICATIONS, href: '/applicants' },
                { label: name }
            ]}
            breadcrumbLinkComponent={Link}
            title={
                <span id={'applicant_name'}>
                    {name}
                    {flaggedBusinessType &&
                        <FlagIcon title={`${flaggedBusinessType} is a flagged business type in your settings`}
                            fontSize='inherit' style={{ fontSize: '0.75em', marginLeft: 8, verticalAlign: '-0.08em' }} />}
                </span>
            }
            actions={
                <>
                    {(AuthService.isReadOnlyUser() || isBrokerCustomer) &&
                        <span className='applicationStatus' style={{
                            background: Status.find(st => st.status === status)?.code,
                            color: Status.find(st => st.status === status)?.color,
                        }}>{status}</span>
                    }
                    {canShare &&
                        <>
                            <Button variant='outlined' color='primary' onClick={() => setShareOpen(true)}>
                                Share with sales rep
                            </Button>
                            <ShareWithSalesRepsModal
                                open={shareOpen}
                                onClose={() => setShareOpen(false)}
                                applicationId={applicantUUID}
                                businessName={name}
                            />
                        </>
                    }
                    {monitoringEnabled && !isReadOnlyUser && !isBrokerCustomer &&
                        <DsButton
                            variant='secondary'
                            size='small'
                            pill
                            className='monitoringPill'
                            onClick={() => onMonitoringClick(!!showMonitoringEnabledBtn)}
                        >
                            {showMonitoringEnabledBtn
                                ? strings.MONITORINGS.MONITORING_ENABLED
                                : strings.MONITORINGS.MONITORING_DISABLED}
                            <span className={`dot ${showMonitoringEnabledBtn ? 'dot-green' : 'dot-grey'}`} />
                        </DsButton>
                    }
                    {!AuthService.isReadOnlyUser() && !isBrokerCustomer &&
                        <div className='applicantChangeStatus'>
                            <ApplicationStatusDropdown
                                status={status}
                                updateApplicationStatus={updateStatus}
                                dispatchProcessing={dispatchProcessing}
                                updateStatus={updateStatus}
                                applicantUUID={applicantUUID}
                                flaggedBusinessType={flaggedBusinessType}
                            />
                        </div>
                    }
                </>
            }
        />
    )
}

let tabChanged = true;
const ApplicantDetail = (props) => {
    const {
        dispatch,
        reset,
        dirty,
        history,
        monitoringConfig,
        getMonitoringConfig,
        updateMonitoringConfig,
        clientFormConfig,
        location: { search, state },
        applicantUUID, // applicant id from params
        applicationData,
        formMode,
        modalMode,
        dispatchProcessing,
        requestFmcsaDataByApplication,
        getFmcsaDataByApplication,
        downloadFMCSAReport,
        getVerifications,
        getVerificationData,
        requestVerificationReportDemo,
        saveVerificationReport,
        attachVerificationReport,
        verificationList,
        verificationData,
        handleSubmit,
        change,
        updateApplicationStatus,
        requestReports, // action to request reports
        getApplicantsById, // action to get applicant details
        getBrokersApplicantsById,
        createNotes,
        getMemoStatus,
        memoStatus,
        getNotes,
        brokerGetNotes,
        brokerCreateNotes,
        notesList,
        sendMessage,
        getMessages,
        messagesList,
        getUccList,
        uccList,
        getUccData,
        uccFilingList,
        uccSearch,
        requestUccFilingImage,
        finishSearch,
        reopenSearch,
        getCreditList,
        getFilingDetails,
        getTerminationPreview,
        terminateUCC,
        savefiling,
        getSavedDetail,
        deleteReport,
        retrieveDocument,
        getRetrieveDocuments,
        postFiling,
        getBgvList,
        searchResult,
        performBgvSearch,
        bgvList,
        getConnectedBuisnessList,
        connectedBuisnessList,
        saveBgvReport,
        saveBgvReportDemoMode,
        getDetailedBusinessReport,
        detailedBusinessReport,
        saveBuisnessReport,
        saveBusinessReportDemoMode,
        getConnectedBuisnessReport,
        saveConnectedBuisnessReport,
        getBackgroundSearchSavedReport,
        attachFile,
        getUccFilingList,
        getJurisdictionList,
        getdirectAmendmentsList,
        directAmendmentList,
        getTemplates,
        filingPreview,
        performCreditSearch,
        getCompanyReport,
        saveReport,
        getUccFilingDetailsByEntity,
        getUccFilingDetailsByFilingNumber,
        getUccFilingDetailsByFilingId,
        getAllDataStatus,
        uploadFile,
        uploadRoxFiles,
        getFilingReportsAttachments,
        getFiles,
        deleteFile,
        downLoadAttachment,
        downloadFileByPayload,
        downloadAttachedFiles,
        getAttachmentPDF,
        downLoadAttachmentByFileId,
        requestUCCForceUpdate,
        attachmentList,
        totalPages,
        totalRecords,
        bankTransactionsList, // List of Bank Transactions
        totalRecordsBT, // Total records Bank Transactions
        totalPagesBT, // Total pages Bank Transactions
        recurrentBankTransactionsList, // List of Recurrent Bank Transactions
        totalRecordsRBT, // Total records Recurrent Bank Transactions
        totalPagesRBT, // Total pages Recurrent Bank Transactions
        getSalesRepresentatives,
        requestBankDataAccess,
        sendEmailToOwnerDueCurrentStatus,
        requestAccounts,
        requestBankTransactions,
        requestRecurrentBankTransactions,
        getListOfAccounts,
        getListOfBankTransactions,
        getDataForInsights,
        getListOfRecurrentBankTransactions,
        getBankDataRequests,
        getRecurrentTransactionData,
        fetchClientFormConfig,
        // Old Header ================
        dispatchFormMode,
        formValues,
        updateBusiness,
        updateDebtor,
        updateOwner,
        createOwner,
        mcNumber,
        identifications,
        // ===========================
        assetsReportData,
        getAssetsReportData,
        assetsReportTransactions,
        assetsReportTransactionsHeaders,
        getAssetsReportTransactions,
        resetAssetsReportData
    } = props
    const {
        status,
        business,
        businessTypeFlagged,
        indexName,
        owners = [],
        debtor,
        riskScore,
        debtorApplication,
        monitoringEnabled,
        // Old Header ================
        salesRepresentative,
        // ===========================
        draftApplication,
        getAllReportAvailable,
        businessDisclosures,
        hasDocusignEnabled
    } = applicationData
    const { isDemoMode } = useAppContext()
    const { hasClientPortal } = useAppContext();
    const initialDemoMode = useRef(isDemoMode).current;
    const client = useSelector(state => state.user.userDetails.securityContext.client);

    // Check if user is a broker customer
    const isBrokerCustomer = AuthService.isBrokerCustomer && AuthService.isBrokerCustomer()
    // Choose the appropriate API function based on user role
    const getApplicantData = isBrokerCustomer ? getBrokersApplicantsById : getApplicantsById

    const businessEin = useMemo(() => {
        const list = business?.identifications || []
        const match = list.find(item => item.identificationType === 'EIN') || list[0]
        return match?.identification || ''
    }, [business])

    const { balanceSheetAnalysis, incomeStatementAnalysis, cashFlowStatementAnalysis, dscrAnalysis, taxrockEnabled } = AuthService.getClientFeatures()

    const visibleReports = useMemo(() => getVisibleReports({
        client,
        isDemoMode,
        isBrokerCustomer,
        hasClientPortal,
        draftApplication,
        hasDocusignEnabled,
        balanceSheetAnalysis,
        incomeStatementAnalysis,
        cashFlowStatementAnalysis,
        dscrAnalysis,
        taxrockEnabled
    }), [client, isDemoMode, isBrokerCustomer, hasClientPortal, draftApplication, hasDocusignEnabled, balanceSheetAnalysis, incomeStatementAnalysis, cashFlowStatementAnalysis, dscrAnalysis, taxrockEnabled]);

    const reportFromUrl = findReportBySlug(visibleReports, queryString.parse(search).tab)
    const [activeReportId, setActiveReportId] = useState(reportFromUrl?.id || visibleReports[0]?.id);
    // Keep the active tab in sync with the URL even when we're already on this
    // application route (e.g. a notification deep-link to ?tab=tasks while the
    // page is already mounted). Without this, the query string changes but the
    // visible tab stays on whatever was previously selected.
    useEffect(() => {
        const tabParam = queryString.parse(search).tab
        if (!tabParam) return
        const report = findReportBySlug(visibleReports, tabParam)
        if (report && report.id !== activeReportId) {
            setActiveReportId(report.id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, visibleReports]);

    useEffect(() => {
        if (visibleReports.length && !visibleReports.some(report => report.id === activeReportId)) {
            setActiveReportId(visibleReports[0].id)
        }
    }, [visibleReports, activeReportId]);

    const [updateSummaryCard, setUpdateSummaryCard] = useState(0)
    const [updateSummary, setUpdateSummary] = useState(0)
    const [loadedApp, setLoadedApp] = useState(false)
    const [isGetAllData, setIsGetAllData] = useState(false);
    const [displayGAD, setDisplayGAD] = useState(false)
    const [notRunCount, setNotRunCount] = useState(0)
    const ref = useRef();
    const [getAllDataLoading, setGetAllDataLoading] = useState(false);
    const [startPolling, setStartPolling] = useState(setGetAllDataLoading);
    const [creditCosts, setCreditCosts] = useState([])
    const { isReadOnlyUser, creditUsageEnabled, newApplicationDetail } = AuthService.getClientFeatures()

    // Old Header =============================================================================================
    const [appTabValue, setAppTabValue] = useState(0);
    const [modal, setModal] = useState({
        business: false,
        owner: false,
        debtor: false
    })

    useEffect(() => {
        if (initialDemoMode !== isDemoMode) {
            history.push("/applicants")
        }
    }, [isDemoMode, history, initialDemoMode])

    // Fetch credit costs overview only when credit usage is enabled
    useEffect(() => {
        if (applicantUUID && creditUsageEnabled) {
            getCreditCostsOverview(applicantUUID)()
                .then((res) => {
                    setCreditCosts(res || []);
                })
                .catch((err) => {
                    console.error('Error fetching credit costs:', err);
                    setCreditCosts([]);
                });
        }
    }, [applicantUUID, creditUsageEnabled])

    const ownerSubmit = (formData) => {
        const callApi = formMode.mode === 'Create' ? createOwner : updateOwner

        if (!formData?.identifications[0]?.identification)
            delete formData.identifications

        if (formMode.mode === "Edit" && formData?.identifications?.length)
            formData.identifications = formData.identifications.map(data => ({
                ...data,
                identificationType: 'SSN',
                'primary': true
            }))

        callApi(applicantUUID, formData).then(() => {
            getApplication()
            updateUccData()
        }).finally(() => {
            setModal({
                ...modal,
                owner: false
            })
        })
    }

    const editBusiness = (formData) => {
        if (typeof formData?.contractAmount === "string") {
            formData.contractAmount = Number(formData.contractAmount.split(",").join(""))
        }
        if (formData.hasOwnProperty('identifications') && Array.isArray(formData.identifications)
            && formData.identifications.length > 0) {
            if (typeof formData?.identifications[0].identification === "string") {
                if (formData.identifications[0].identification.length > 0) {
                    formData.identifications[0].identificationType = 'EIN'
                    formData.identifications[0].primary = true
                } else {
                    delete formData.identifications;
                }
            }
        }

        updateBusiness(applicantUUID, formData).then(() => {
            getApplication()
            updateUccData()
        }).finally(() => {
            setModal({
                ...modal,
                business: false
            })
        })
    }

    const editDebtor = (formData) => {
        const type = formMode.mode === 'Create' ? 'POST' : 'PATCH'

        if (!formData.emails || !formData.emails[0]?.email) {
            formData.emails = null
        } else {
            formData.emails[0].emailType = 'Work'
            formData.emails[0].primary = true
        }

        if (!formData.phones[0] || !formData.phones[0]?.number) {
            formData.phones = null;
        } else {
            formData.phones[0].phoneType = 'Work';
            formData.phones[0].primary = true;
        }

        if (!formData.identifications || !formData.identifications[0]?.identification) {
            formData.identifications = null
        } else {
            formData.identifications[0].identificationType = 'EIN'
        }

        updateDebtor(applicantUUID, formData, type).then(() => {
            getApplication()
        }).finally(() => {
            setModal({
                ...modal,
                debtor: false
            })
        })
    }

    const updateUccData = () => {
        if (activeReportId === 'UCC') {
            setLoadedApp(false)
            Promise.all([
                getUccList(applicantUUID),
                getUccFilingList(applicantUUID)
            ]).finally(() => {
                setLoadedApp(true)
            })
        }
    }

    const handleApplicationTabChange = (event, newValue) => {
        setAppTabValue(newValue)
    }

    const dialogControl = (key, mode, id) => {
        reset('editForm')
        dispatchFormMode({
            mode: mode,
            type: key,
            id
        })
        setModal({
            ...modal,
            [key]: !modal[key]
        })
    }

    const renderApplicationTab = (column, data, keyField) => (
        <TableComponent
            columns={column}
            data={data}
            keyField={keyField}
            showPagination={false}
            className='mt-3 customTable'
        />
    )

    const action = {
        formatter: (cell, row, rowIndex) => {
            let type = 'business'
            if (appTabValue === 1)
                type = 'owner'
            else if (appTabValue === 2)
                type = 'debtor'

            return (
                <img src={EditIcon} alt="Edit Icon" onClick={() => dialogControl(type, 'Edit', row.uuid)} />
            )
        }
    }

    const headerFormatter = () => {
        if (owners.length < 5)
            return (
                <img src={AddIcon} alt="Add Icon" title='Add Owner' onClick={() => {
                    dialogControl("owner", 'Create', Math.random())
                }} />
            );
    }

    const DebtorHeaderFormatter = () => {
        if (!Object.keys(debtor || {}).length)
            return (
                <img src={AddIcon} alt="Add Icon" title='Add Debtor' onClick={() => {
                    dialogControl("debtor", 'Create', Math.random())
                }} />
            );
    }

    const buisnessColumns = cloneDeep(BuisnessColumns)
    const debtorColumns = cloneDeep(BuisnessColumns)
    if (!AuthService.isReadOnlyUser()) {
        buisnessColumns.map((item, index) => {
            if (item.dataField === 'action')
                buisnessColumns[index] = { ...item, ...action }
            return item
        })

        debtorColumns.map((item, index) => {
            if (item.dataField === 'action')
                debtorColumns[index] = { ...item, ...action, headerFormatter: DebtorHeaderFormatter }
            return item
        })

        OwnersColumn.map((item, index) => {
            if (item.dataField === 'action')
                OwnersColumn[index] = { ...item, ...action, headerFormatter }
            return item
        })
    }
    // ========================================================================================================

    // handle get all data button click
    const handleGetAllData = async (applicantId) => {
        setGetAllDataLoading(true);
        setStartPolling(true)
        Toast({ type: "info", message: strings.APPLICANT.DECISIONER.REQUESTING_PULL_REPORTS });
        // Fire the initial request asynchronously
        await requestReports(applicantId, null, isDemoMode)
            .then(() => {
            });
    };

    const pollingRef = useRef();

    useEffect(() => {
        if (!startPolling) return;
        if (!applicantUUID || !getAllDataStatus) return;
        if (pollingRef.current) clearInterval(pollingRef.current);
        pollingRef.current = setInterval(async () => {
            const res = await getAllDataStatus(applicantUUID);
            // If status is not 'Completed', stop polling and set loading false
            if (res && res.status === 'In Progress') {
                Toast({ type: "info", message: res.statusDescription });
            }
            if (res && res.status === 'Completed') {
                clearInterval(pollingRef.current);
                setGetAllDataLoading(false);
                setStartPolling(false);
                setIsGetAllData(true);
                if (res.message) {
                    Toast({ type: res.result === 'PROCESS_FINISHED' ? "success" : "warn", message: res.message });
                }
            }
        }, 5000);
        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
            setStartPolling(false);
            handleUpdateSummaryCard();
            getApplicantData(applicantUUID);
            setUpdateSummary(updateSummary => updateSummary + 1);
        };
    }, [startPolling, applicantUUID, getAllDataStatus, getApplicantData]);

    const handleUpdateSummaryCard = () => {
        setUpdateSummaryCard(updateSummaryCard => updateSummaryCard + 1)
    }

    const getApplication = useCallback(() => {
        dispatchProcessing(true)
        setLoadedApp(false)
        getApplicantData(applicantUUID).finally(() => {
            dispatchProcessing(false)
            setLoadedApp(true)
        })
    }, [applicantUUID, getApplicantData, dispatchProcessing])

    useEffect(() => {
        //When Opening App Detail First Time, requesting App Data
        if ((!business || !state) && !ref.current) {
            getApplication()
        }
        //If just tab change, don't request App Data again
        if (business && state) {
            setLoadedApp(true)
        }
    }, [getApplication, business, state])

    useEffect(() => {
        ref.current = true
    }, [])

    const newBusinessReports = useMemo(() => {
        const reasons = {
            'Bank Transactions': 'real cash flow, even for a few months of history',
            SOS: 'formation date, status and officers from the state',
            TinVerification: 'EIN matches the legal name',
            Verification: 'identity checks for the business and owners',
            HEALTHCARE_SEARCH: 'provider, exclusion and sanction checks for the business and owners',
            NPPES: 'provider registration and enumeration date',
            LEIE: 'healthcare exclusions for the business and owners',
            'Reputational Report': 'news and reviews',
        }
        return visibleReports.filter(report => reasons[report.id]).map(report => ({ id: report.id, label: report.label, reason: reasons[report.id] }))
    }, [visibleReports]);

    const handleDetailTabChange = useCallback((event, reportId) => {
        const report = resolveReport(visibleReports, reportId)
        if (!report) return

        window.scrollTo({ top: 0, behavior: 'smooth' })

        if (report.id === activeReportId) return

        setActiveReportId(report.id)
        const params = { ...queryString.parse(search), tab: report.slug }
        history.replace(`?${queryString.stringify(params)}`, true)
        tabChanged = true
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleReports, activeReportId, search]);

    const [monitoringDrawerOpen, setMonitoringDrawerOpen] = useState(false);
    const [monitoringStatus, setMonitoringStatus] = useState(false); // <-- Add this

    useEffect(() => {
        if (!applicantUUID || !getAllDataStatus) return;
        // Fetch status when details are opened
        (async () => {
            const res = await getAllDataStatus(applicantUUID);
            if (res && res.status === 'In Progress') {
                setStartPolling(true);
                setGetAllDataLoading(true);
            }
        })();
    }, [applicantUUID, displayGAD, getAllDataStatus, activeReportId]);

    const tabItems = useMemo(
        () => visibleReports.map(report => ({ label: report.label, value: report.id })),
        [visibleReports]
    )

    const layoutOverride = queryString.parse(search).layout
    const useReportsRail = layoutOverride === 'new'
        ? true
        : layoutOverride === 'old'
            ? false
            : newApplicationDetail

    const reportPanels = {
        'Overview': (
            <>
                {!isReadOnlyUser && !isBrokerCustomer &&
                    <GetAllDataAlert isBrokerCustomer={isBrokerCustomer} display={displayGAD} handleGetAllData={handleGetAllData} applicantId={applicantUUID} loading={getAllDataLoading} creditCosts={creditCosts} creditUsageEnabled={creditUsageEnabled} count={notRunCount} />
                }
                <Overview
                    applicantId={applicantUUID}
                    formMode={formMode}
                    modalMode={modalMode}
                    businessData={business}
                    debtorData={debtor}
                    ownersData={owners}
                    hideFmcsa={client?.hideFmcsa}
                    getSalesRepresentatives={getSalesRepresentatives}
                    reset={reset}
                    dispatch={dispatch}
                    handleSubmit={handleSubmit}
                    dirty={dirty}
                    change={change}
                    isBrokerCustomer={isBrokerCustomer}
                />
                <Summary
                    setNotRunCount={setNotRunCount}
                    getAllReportAvailable={getAllReportAvailable}
                    draftApplication={draftApplication}
                    businessDisclosures={businessDisclosures}
                    applicantId={applicantUUID}
                    updates={updateSummary}
                    changeTab={handleDetailTabChange}
                    isGetAllData={isGetAllData}
                    handleGetAllData={handleGetAllData}
                    updateSummaryCard={handleUpdateSummaryCard}
                    setDisplayGAD={setDisplayGAD}
                    getRetrieveDocuments={getRetrieveDocuments}
                    getFilingReportsAttachments={getFilingReportsAttachments}
                    dispatchProcessing={dispatchProcessing}
                    sosSearchEnabled={client.sosSearchEnabled}
                    debtorApplication={debtorApplication}
                    creditCosts={creditCosts}
                    creditUsageEnabled={creditUsageEnabled}
                    isBrokerCustomer={isBrokerCustomer}
                />
            </>
        ),
        'FMCSA': (
            <FmcsaVerification
                getFmcsaDataByApplication={getFmcsaDataByApplication}
                requestFmcsaDataByApplication={requestFmcsaDataByApplication}
                dot={business?.dotNumber}
                downloadFMCSAReport={downloadFMCSAReport}
                applicationId={applicantUUID}
                uploadRoxFiles={uploadRoxFiles}
                updateSummaryCard={handleUpdateSummaryCard}
                creditUsageEnabled={creditUsageEnabled}
                creditCosts={creditCosts}
            />
        ),
        'Motus': (
            <MotusTab
                creditCosts={creditCosts}
                applicationId={applicantUUID}
                businessName={business?.name}
                dot={business?.dotNumber}
            />
        ),
        'SOS': (
            <SosTabContent
                creditCosts={creditCosts}
                updateSummaryCard={handleUpdateSummaryCard}
            />
        ),
        'TinVerification': (
            <TinVerification
                applicationId={applicantUUID}
                businessName={business?.name}
                ein={business?.identifications?.[0]?.identification}
                creditCosts={creditCosts}
                creditUsageEnabled={creditUsageEnabled}
            />
        ),
        'Verification': (
            <Verification
                applicationId={applicantUUID}
                getVerifications={getVerifications}
                verificationList={verificationList}
                getVerificationData={getVerificationData}
                verificationData={verificationData}
                saveVerificationReport={saveVerificationReport}
                downloadFile={downLoadAttachment}
                attachVerificationReport={attachVerificationReport}
                updateSummaryCard={handleUpdateSummaryCard}
                creditCosts={creditCosts}
            />
        ),
        'Background': (
            <Bgv
                creditCosts={creditCosts}
                suggestedReports={newBusinessReports}
                onOpenReport={reportId => handleDetailTabChange(null, reportId)}
                applicationEin={businessEin}
                getBgvList={getBgvList}
                applicationId={applicantUUID}
                performBgvSearch={performBgvSearch}
                saveBgvReport={saveBgvReport}
                saveBgvReportDemoMode={saveBgvReportDemoMode}
                bgvList={bgvList}
                getConnectedBuisnessList={getConnectedBuisnessList}
                connectedBuisnessList={connectedBuisnessList}
                searchResult={searchResult}
                getDetailedBusinessReport={getDetailedBusinessReport}
                detailedBusinessReport={detailedBusinessReport}
                saveBuisnessReport={saveBuisnessReport}
                saveBusinessReportDemoMode={saveBusinessReportDemoMode}
                getConnectedBuisnessReport={getConnectedBuisnessReport}
                saveConnectedBuisnessReport={saveConnectedBuisnessReport}
                downloadFile={downLoadAttachment}
                attachFile={attachFile}
                updateSummaryCard={handleUpdateSummaryCard}
                getBackgroundSearchSavedReport={getBackgroundSearchSavedReport}
                refreshBgvReport={refreshBgvReport}
                getBgvReportHistory={getBgvReportHistory}
            />
        ),
        'UCC': (
            <Ucc
                requestUccFilingImage={requestUccFilingImage}
                getUccList={getUccList}
                getUccData={getUccData}
                getUccFilingList={getUccFilingList}
                applicationId={applicantUUID}
                uccList={uccList}
                uccFilingList={uccFilingList}
                uccSearch={uccSearch}
                finishSearch={finishSearch}
                reopenSearch={reopenSearch}
                filingDetails={getFilingDetails}
                getTerminationPreview={getTerminationPreview}
                terminateUCC={terminateUCC}
                savefiling={savefiling}
                getSavedDetail={getSavedDetail}
                deleteReport={deleteReport}
                retrieveDocument={retrieveDocument}
                getRetrieveDocuments={getRetrieveDocuments}
                postFiling={postFiling}
                getJurisdictionList={getJurisdictionList}
                getdirectAmendmentsList={getdirectAmendmentsList}
                directAmendmentList={directAmendmentList}
                getTemplates={getTemplates}
                filingPreview={filingPreview}
                handleSubmit={handleSubmit}
                change={change}
                resetForm={() => reset('editForm')}
                getUccFilingDetailsByEntity={getUccFilingDetailsByEntity}
                getUccFilingDetailsByFilingNumber={getUccFilingDetailsByFilingNumber}
                getUccFilingDetailsByFilingId={getUccFilingDetailsByFilingId}
                tabChanged={{ changed: tabChanged, setChanged: () => tabChanged = false }}
                // Attachment props
                onSubmit={uploadFile}
                uploadRoxFiles={uploadRoxFiles}
                getFilingReportsAttachments={getFilingReportsAttachments}
                getFiles={getFiles}
                attachmentList={attachmentList}
                downLoadAttachment={downLoadAttachment}
                downLoadAttachmentByFileId={downLoadAttachmentByFileId}
                requestUCCForceUpdate={requestUCCForceUpdate}
                totalPages={totalPages}
                totalRecords={totalRecords}
                getAttachmentPDF={getAttachmentPDF}
                dispatchProcessing={dispatchProcessing}
                updateSummaryCard={handleUpdateSummaryCard}
                debtorApplication={debtorApplication}
            />
        ),
        'New UCC': (
            <NewUCCTabContent
                applicationId={applicantUUID}
                handleSubmitUccPosting={handleSubmit}
                creditCosts={creditCosts}
                debtorApplication={debtorApplication}
                creditUsageEnabled={creditUsageEnabled}
            />
        ),
        'Credit Check': (
            <CreditCheck
                getCreditList={getCreditList}
                applicationId={applicantUUID}
                performCreditSearch={performCreditSearch}
                getCompanyReport={getCompanyReport}
                saveReport={saveReport}
            />
        ),
        'AR Balance': (
            <ArBalance
                applicationId={applicantUUID}
                creditCosts={creditCosts}
            />
        ),
        'Bank Transactions': (
            <BankDataSection
                hasPlaidAccess={!!applicationData?.hasPlaidAccess}
                change={change}
                applicantUUID={applicantUUID}
                owners={owners}
                requestBankDataAccess={requestBankDataAccess}
                sendEmailToOwnerDueCurrentStatus={sendEmailToOwnerDueCurrentStatus}
                requestAccounts={requestAccounts}
                requestBankTransactions={requestBankTransactions}
                requestRecurrentBankTransactions={requestRecurrentBankTransactions}
                getListOfAccounts={getListOfAccounts}
                getListOfBankTransactions={getListOfBankTransactions}
                getDataForInsights={getDataForInsights}
                getListOfRecurrentBankTransactions={getListOfRecurrentBankTransactions}
                getBankDataRequests={getBankDataRequests}
                getRecurrentTransactionData={getRecurrentTransactionData}
                bankTransactionsList={bankTransactionsList}
                totalRecordsBT={totalRecordsBT}
                totalPagesBT={totalPagesBT}
                recurrentBankTransactionsList={recurrentBankTransactionsList}
                totalRecordsRBT={totalRecordsRBT}
                totalPagesRBT={totalPagesRBT}
                creditCosts={creditCosts}
                assetsReportData={assetsReportData}
                assetsReportTransactions={assetsReportTransactions}
                assetsReportTransactionsHeaders={assetsReportTransactionsHeaders}
                getAssetsReportData={getAssetsReportData}
                getAssetsReportTransactions={getAssetsReportTransactions}
                resetAssetsReportData={resetAssetsReportData}
                client={client}
            />
        ),
        'Balance Sheet': (
            <BalanceSheet
                applicationId={applicantUUID}
                creditCosts={creditCosts}
            />
        ),
        'Income Statement': (
            <IncomeStatement
                applicationId={applicantUUID}
                creditCosts={creditCosts}
            />
        ),
        'Cash Flow': (
            <CashFlowStatement
                applicationId={applicantUUID}
                creditCosts={creditCosts}
            />
        ),
        'DSCR': (
            <Dscr applicationId={applicantUUID} />
        ),
        'Taxes': (
            <Taxes
                applicationId={applicantUUID}
                businessEin={businessEin}
                creditCosts={creditCosts}
                onBusinessUpdated={getApplication}
            />
        ),
        'Terms': (
            <Terms
                applicantId={applicantUUID}
            />
        ),
        'Credit Memo': (
            <CreditMemo
                applicantId={applicantUUID}
                creditCosts={creditCosts}
                updates={updateSummaryCard}
            />
        ),
        'Messages': (
            <Messages
                applicantId={applicantUUID}
                messages={messagesList}
                sendMessage={sendMessage}
                getMessages={getMessages}
                clientId={2}
                onSendMessage={(message) => {
                    sendMessage(applicantUUID, message).then(() => {
                        // Refresh messages after sending
                        getMessages(applicantUUID);
                    });
                }}
            />
        ),
        'Notes': (
            <Notes
                createNotes={createNotes}
                getNotes={getNotes}
                brokerCreateNotes={brokerCreateNotes}
                brokerGetNotes={brokerGetNotes}
                applicantId={applicantUUID}
                notesList={notesList}
                isBrokerCustomer={isBrokerCustomer}
                salesRepresentative={salesRepresentative}
            />
        ),
        'Reputational Report': (
            <ReputationalReport
                applicantId={applicantUUID}
                applicationName={business?.name}
                creditCosts={creditCosts}
                creditUsageEnabled={creditUsageEnabled}
            />
        ),
        'Attachments': (
            <Attachments
                creditCosts={creditCosts}
                onSubmit={uploadFile}
                getFiles={getFiles}
                deleteFile={deleteFile}
                downloadFileByPayload={downloadFileByPayload}
                downloadFile={downLoadAttachment}
                downloadAttachedFiles={downloadAttachedFiles}
                businessName={indexName}
                getAttachmentPDF={getAttachmentPDF}
                attachmentList={attachmentList}
                totalPages={totalPages}
                totalRecords={totalRecords}
                applicationId={applicantUUID}
                getMemoStatus={getMemoStatus}
                memoStatus={memoStatus}
            />
        ),
        'Tasks': (
            <TasksTab
                applicationUuid={applicantUUID}
                applicationRef={applicationData?.id ? `APP-${applicationData.id}` : null}
                highlightTaskId={queryString.parse(search).task || null}
            />
        ),
        'SAM.gov': <SamgovTabContent applicantId={applicantUUID} />,
        'NPPES': <NppesTabContent applicantId={applicantUUID} />,
        'LEIE': <LeieTabContent applicantId={applicantUUID} />,
        'STATE_MEDICAID': <StateMedicaidTabContent applicantId={applicantUUID} />,
        'HEALTHCARE_SEARCH': <HealthcareSearchTabContent applicantId={applicantUUID} creditCosts={creditCosts} />
    }

    const renderedPanels = visibleReports.map(report => (
        <Tab
            key={report.id}
            value={activeReportId}
            index={report.id}
            className='appDetailTab'
        >
            {reportPanels[report.id]}
        </Tab>
    ))

    return (
        <div className='applicant'>
            {loadedApp &&
                <div>
                    <ApplicantHeader
                        name={business?.name}
                        status={status}
                        updateStatus={updateApplicationStatus}
                        dispatchProcessing={dispatchProcessing}
                        applicantUUID={applicantUUID}
                        riskScore={riskScore}
                        showDecisioningFeatures={!client?.hideDecisioning}
                        monitoringConfig={monitoringConfig}
                        showMonitoringEnabledBtn={monitoringEnabled}
                        isBrokerCustomer={isBrokerCustomer}
                        flaggedBusinessType={businessTypeFlagged ? business?.businessType : null}
                        onMonitoringClick={(status) => {
                            setMonitoringStatus(status);
                            setMonitoringDrawerOpen(true)
                            dispatchFormMode({
                                mode: 'Edit',
                                type: 'monitoring',
                                id: applicantUUID
                            })
                        }}
                    />
                    {/* Old Header ================================================================================= */}
                    {client.hideDecisioning &&
                        <div className='ownerTabpanel'>
                            <Tabs
                                data={applicationTabs}
                                value={appTabValue}
                                onChange={handleApplicationTabChange}
                            />
                            <Tab value={appTabValue} index={0}>
                                {renderApplicationTab(buisnessColumns, [{ ...business, salesRepresentative }], 'name')}
                            </Tab>
                            <Tab value={appTabValue} index={1}>
                                {renderApplicationTab(OwnersColumn, owners, 'uuid')}
                            </Tab>
                            <Tab value={appTabValue} index={2}>
                                {renderApplicationTab(debtorColumns, [debtor || {}], 'name')}
                            </Tab>
                        </div>
                    }
                    {/* ============================================================================================ */}
                    {useReportsRail && !client?.hideDecisioning &&
                        <SummaryStrip applicantId={applicantUUID} updates={updateSummaryCard} />
                    }
                    <Row>
                        {!client?.hideDecisioning && !useReportsRail &&
                            <Col md={3} className='pl-3 pr-0'>
                                <SummaryCard applicantId={applicantUUID} updates={updateSummaryCard} ></SummaryCard>
                            </Col>
                        }
                        <Col md={(!client?.hideDecisioning && !useReportsRail) ? 9 : 12} className='pl-3 pr-3'>
                            <div className={`${useReportsRail ? 'tabPanel--bare' : 'tabPanel'} mt-3`}>
                                {useReportsRail
                                    ? (
                                        <div className='reportsLayout'>
                                            <ReportsRail
                                                reports={visibleReports}
                                                activeReportId={activeReportId}
                                                onSelect={(reportId) => handleDetailTabChange(null, reportId)}
                                                applicantId={applicantUUID}
                                                updates={updateSummaryCard}
                                            />
                                            <div className='reportsLayout__panel'>{renderedPanels}</div>
                                        </div>
                                    )
                                    : (
                                        <>
                                            <Tabs scrollable={true}
                                                data={tabItems}
                                                value={activeReportId || false}
                                                onChange={handleDetailTabChange}
                                            />
                                            {renderedPanels}
                                        </>
                                    )
                                }

                            </div>
                        </Col>
                    </Row>
                    {AuthService.getClientFeatures().monitoringAdvancedEnabled ? (
                        <ReportsMonitoringDrawer
                            open={monitoringDrawerOpen}
                            monitoringConfig={monitoringConfig}
                            getMonitoringConfig={getMonitoringConfig}
                            updateMonitoringConfig={updateMonitoringConfig}
                            roxAppId={applicantUUID}
                            onClose={() => setMonitoringDrawerOpen(false)}
                            monitoringStatus={monitoringStatus}
                            handleSubmit={handleSubmit}
                            getApplication={getApplication}
                        />
                    ) : (
                        <ReportsMonitoringDrawerLegacy
                            open={monitoringDrawerOpen}
                            monitoringConfig={monitoringConfig}
                            getMonitoringConfig={getMonitoringConfig}
                            updateMonitoringConfig={updateMonitoringConfig}
                            roxAppId={applicantUUID}
                            onClose={() => setMonitoringDrawerOpen(false)}
                            monitoringStatus={monitoringStatus}
                            handleSubmit={handleSubmit}
                            getApplication={getApplication}
                        />
                    )}
                    {/* Old Header ====================================================================================== */}
                    <BusinessModal
                        open={modal.business || modal.debtor}
                        onClose={() => {
                            setModal({ ...modal, business: false, debtor: false })
                            dispatchFormMode({
                                mode: 'Default',
                                type: ''
                            })
                        }}
                        formValues={formValues}
                        onSubmit={handleSubmit(formData => appTabValue ? editDebtor(formData) : editBusiness(formData))}
                        ein={identifications}
                        mcNumber={mcNumber}
                        title={appTabValue ? "Edit Debtor" : "Edit Business"}
                        mode={appTabValue ? "Edit" : "Create"}
                        applicantUUID={applicantUUID}
                        isOpen={modal.debtor || modal.business}
                        closeModal={() => setModal({ ...modal, business: false, debtor: false })}
                    // ===========================
                    />
                    <OwnerModal
                        open={modal.owner}
                        onClose={() => setModal({ ...modal, owner: false })}
                        onSubmit={ownerSubmit}
                        title={"Edit Owner"}
                        mode={"Edit"}
                        applicantUUID={applicantUUID}
                        isOpen={modal.owner}
                        closeModal={() => setModal({ ...modal, owner: false })}
                    />
                </div>
            }
        </div>
    )
}

export default reduxForm({
    form: 'editForm',
    enableReinitialize: true,
    destroyOnUnmount: false
})(ApplicantDetail)
